import { Action, combineReducers, Reducer } from "redux";
import { createReducer, PayloadAction } from "typesafe-actions";

import {
  setChatFolderModalIsOpen,
  setChatSelectFolderSettingModalIsOpen,
  setChatSelectFoldersModalIsOpen,
  setNewChatModalIsOpen,
  setNewChatServiceModalIsOpen
} from "./modals.actions";

export interface ModalsStore {
  newChatModalIsOpen: boolean;
  newChatServiceModalIsOpen: boolean;
  setChatFolderModalIsOpen: boolean;
  setChatSelectFoldersModalIsOpen: boolean;
  setChatSelectFolderSettingModalIsOpen: boolean;
}

export const modalsReducer: Reducer<ModalsStore> = combineReducers({
  newChatModalIsOpen: createReducer<boolean, Action>(false).handleAction(
    setNewChatModalIsOpen,
    (_: boolean, { payload }: PayloadAction<string, boolean>) => payload
  ),
  newChatServiceModalIsOpen: createReducer<boolean, Action>(false).handleAction(
    setNewChatServiceModalIsOpen,
    (_: boolean, { payload }: PayloadAction<string, boolean>) => payload
  ),
  setChatFolderModalIsOpen: createReducer<boolean, Action>(false).handleAction(
    setChatFolderModalIsOpen,
    (_: boolean, { payload }: PayloadAction<string, boolean>) => payload
  ),
  setChatSelectFoldersModalIsOpen: createReducer<boolean, Action>(false).handleAction(
    setChatSelectFoldersModalIsOpen,
    (_: boolean, { payload }: PayloadAction<string, boolean>) => payload
  ),
  setChatSelectFolderSettingModalIsOpen: createReducer<boolean, Action>(false).handleAction(
    setChatSelectFolderSettingModalIsOpen,
    (_: boolean, { payload }: PayloadAction<string, boolean>) => payload
  )
});
